import { Component, HostListener, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
//import { SplashScreen } from '@capacitor/splash-screen';

// Import the functions you need from the Firebase SDKs you need
import { FirebaseApp, initializeApp } from 'firebase/app';
import { Analytics, getAnalytics } from 'firebase/analytics';
import 'firebase/messaging';
import { environment } from 'src/environments/environment';
import { NotificationsService } from 'src/app/mastermodule/service/notifications.service';
import { ServiceService } from 'src/app/mastermodule/service/service.service';
import { Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { LocalNotifications, ActionType,
  RegisterActionTypesOptions } from '@capacitor/local-notifications';
import { PushNotifications, ActionPerformed,
  PushNotificationSchema,
  Token } from '@capacitor/push-notifications';
// Add this import at the top
import { Filesystem, Directory } from '@capacitor/filesystem';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  frbs_app: FirebaseApp;
  frbs_analytics: Analytics;

  constructor(
    public platform: Platform,
    public api: ServiceService, // , private notificationsService: NotificationsService
    private NotificationsService: NotificationsService,
    private toastController: ToastController,
    private router: Router,
  ) {}
  user_id: number = null;
  private pushInitialized = false;

  async ngOnInit() {
    // alert("hiii")
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data?.type === 'NOTIFICATION_CLICK') {
        const url: string = event.data.url;
        // Strip the origin to get just the path
        const path = url.replace(window.location.origin, '');
        this.router.navigateByUrl(path);
      }
    });

    // TODO: uncomment to Initialize Firebase
    // Add "src/firebase-messaging-sw.js" to /ionic/postulate_erp/angular.json under assets arrays (projects.app.architect.build.options.assets, projects.app.architect.test.options.assets)
    // this.frbs_app = initializeApp(environment.firebaseConfig);
    // this.frbs_analytics = getAnalytics(this.frbs_app);
    // await this.notificationsService.init();
    this.user_id = Number(this.api.localStorage.getItem('user_id')) || null;
    await this.initializePush();
  }

  ngAfterViewInit() {
    this.platform.ready().then(async () => {
      // window.addEventListener('visibilitychange', function (evt) {
      //   if (document.visibilityState === 'hidden') {
      //     this.unloadNotification(evt);
      //   }
      // });
      // await SplashScreen.hide();
      // TODO: Uncomment for using Firebase
      // await this.notificationsService.requestPermission();
    });
  }

  // Add beforeunload event listener
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
    // if (this.isClosingBrowserOrAllTabs()) {
    //   this.onAppExit($event);
    // }
  }

  // to check if the browser or all tabs are closing
  isClosingBrowserOrAllTabs(): boolean {
    // Check if there is a specific session storage key
    const closingKey = sessionStorage.getItem('closingKey');
    // Set the closing key to identify the unload event
    sessionStorage.setItem('closingKey', 'true');

    // Check if the key was already present
    if (closingKey) {
      // If the key is present, it means a new tab is opening or the user is navigating away
      return false;
    }

    // If the key was not present, it means this is the first unload event
    return true;
  }

  // Handler for beforeunload event
  onAppExit(event) {
    const url = `${environment.API_URL}mastermodule/logout`;

    const data = {
      user_id: this.api.localStorage.getItem('user_id'),
      login_dt: this.api.localStorage.getItem('login_dt'),
      sid: this.api.get_session_id_login(),
      test: true,
    };

    if (navigator.sendBeacon) {
      const blob = new Blob([JSON.stringify(data)], {
        type: 'application/json; charset=UTF-8',
      });
      this.api.clearUserSession();
      // Here we can send a synchronous request, which is discouraged but can be done for session cleanup
      navigator.sendBeacon(url, blob);
    } else {
      // Fallback for browsers that do not support sendBeacon
      const headers = {
        'Content-Type': 'application/json',
        // 'Authorization': this.api.get_session_id_login()
      };
      this.api.clearUserSession();
      fetch(url, {
        keepalive: true,
        credentials: 'include',
        method: 'POST',
        headers,
        body: JSON.stringify(data),
      });
    }
  }

  async initializePush() {
    await this.platform.ready();
    try {
      await this.createNotificationChannels();
      await this.registerActionButtons();
      // await this.registerStaticActionTypes();
    } catch (e) {
      console.error('Native setup failed (expected on web):', e);
    }
    console.log(this.platform, 'platformmm');
    if (this.platform.is('android') || this.platform.is('ios')) {
      // await this.createNotificationChannels();
      this.initializeMobilePush();
    }

    // if (this.platform.is('desktop') || this.platform.is('mobileweb')) {
    //   this.initializeWebPush();
    // }
    if (!this.platform.is('hybrid')) {
      await this.initializeWebPush();
    }
  }

  /* ----------------------------------------------------
      CREATE NOTIFICATION CHANNELS
  ---------------------------------------------------- */

  async createNotificationChannels() {
    if (!this.platform.is('hybrid')) return;
    const channels = [
      { id: 'basic_channel', name: 'Basic', color: '#FF0000' },
      { id: 'image_channel', name: 'Image', color: '#00FF00' },
      { id: 'color_channel', name: 'Color', color: '#0000FF' },
      { id: 'sound_channel', name: 'Sound', color: '#FFFF00' },
      { id: 'deeplink_channel', name: 'DeepLink', color: '#FF00FF' },
    ];

    for (const ch of channels) {
      await LocalNotifications.createChannel({
        id: ch.id,
        name: ch.name,
        importance: 5,
        sound: 'default',
        vibration: true,
        lightColor: ch.color,
      });
    }
  }

  /* ----------------------------------------------------
      REGISTER ACTION BUTTONS
  ---------------------------------------------------- */
  async registerActionButtons() {
    if (!this.platform.is('hybrid')) return;
    await LocalNotifications.registerActionTypes({
      types: [
        {
          id: 'DYNAMIC_ACTIONS',
          actions: [
            {
              id: 'open',
              title: 'Open',
            },
            {
              id: 'view',
              title: 'View',
            },
            {
              id: 'cancel',
              title: 'Cancel',
              destructive: true,
            },
          ],
        },
      ],
    });
  }
async registerDynamicActions(actions: any[]): Promise<string> {

  const actionTypeId = `DYNAMIC_ACTIONS_${Date.now()}`;

  const dynamicActions = actions.map((a: any) => ({
    id: a.action,
    title: a.title,
    foreground: true,
  }));

  console.log('REGISTERING ACTIONS:', dynamicActions);

  await LocalNotifications.registerActionTypes({
    types: [
      {
        id: actionTypeId,
        actions: dynamicActions,
      },
    ],
  });

  // IMPORTANT DELAY
  await new Promise(resolve => setTimeout(resolve, 500));

  return actionTypeId;
}
 
  /* ============================================================
      IN-APP TOAST BANNER
  ============================================================ */
  async showInAppBanner(title: string, body: string, url?: string) {
    const toast = await this.toastController.create({
      header: title,
      message: body,
      duration: 4000,
      position: 'top',
      buttons: url
        ? [{ text: 'Open', handler: () => this.router.navigateByUrl(url) }]
        : [],
    });
    await toast.present();
  }

  /* ── Download remote image → local cache → return file:// URI ── */
async downloadImageToCache(remoteUrl: string): Promise<string | null> {
  if (!remoteUrl) return null;
  try {
    // Fetch the image as blob
    const response = await fetch(remoteUrl);
    if (!response.ok) return null;
    const blob = await response.blob();

    // Convert blob to base64
    const base64 = await new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const result = reader.result as string;
        resolve(result.split(',')[1]); // strip data:image/...;base64,
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });

    // Save to device cache directory
    const fileName = `notif_${Date.now()}.jpg`;
    await Filesystem.writeFile({
      path: fileName,
      data: base64,
      directory: Directory.Cache,
    });

    // Get the file:// URI
    const uriResult = await Filesystem.getUri({
      path: fileName,
      directory: Directory.Cache,
    });

    console.log('[IMAGE CACHE] Saved to:', uriResult.uri);
    return uriResult.uri; // e.g. file:///data/user/0/.../cache/notif_xxx.jpg

  } catch (e) {
    console.error('[IMAGE CACHE] Failed:', e);
    return null;
  }
}
initializeMobilePush() {
  PushNotifications.removeAllListeners();

  PushNotifications.checkPermissions().then(async (perm) => {
    if (perm.receive === 'prompt') {
      perm = await PushNotifications.requestPermissions();
    }
    if (perm.receive !== 'granted') return;
    await PushNotifications.register();
  });

  PushNotifications.addListener('registration', (token) => {
    console.log('ANDROID TOKEN:', token.value);
    const oldToken = this.api.localStorage.getItem('fcm_token');
    if (oldToken === token.value) return;
    this.api.localStorage.setItem('fcm_token', token.value);
    if (this.user_id) this.saveTokenToBackend(token.value);
  });

  PushNotifications.addListener('registrationError', (error) => {
    console.error('FCM Registration Error:', error);
  });

  // ── FOREGROUND: App is open ──────────────────────────────────────────────
  // FCM does NOT show a heads-up notification when the app is in foreground.
  // We must manually schedule a LocalNotification OR show an in-app banner.
//   PushNotifications.addListener('pushNotificationReceived', async (notification) => {
//     const data = notification.data || {};
//     const type = data['type'] || 'basic';
//     const title = data['title'] || notification.title || 'Notification';
//     const body  = data['body']  || notification.body  || '';
//     const url   = data['url']   || '/';
//     const image = data['image'] || '';
//     let actions: any[] = [];

// try {
//   actions = JSON.parse(data['actions'] || '[]');
// } catch (e) {
//   console.error('Invalid actions JSON', e);
// }

//     console.log(`[FOREGROUND] type=${type}`);

//     if (type === 'basic') {
//       // ── Type 1: Basic — simple in-app banner ──────────────────────────
//       this.showInAppBanner(title, body, url);

//     } else if (type === 'image') {
//       // ── Type 2: Image only — LocalNotification with big picture ───────
//       // FCM natively shows the image when app is in background/killed.
//       // In foreground we schedule a LocalNotification to show the big picture.
//       await LocalNotifications.schedule({
//         notifications: [{
//           id: Number(data['notification_id']) || Math.floor(Math.random() * 2147483647),
//           title,
//           body,
//           largeBody: body,
//           smallIcon: 'ic_push_notification',
//           // largeIcon renders the big picture on Android
//           largeIcon: image || undefined,
//           channelId: data['channel_id'] || 'deeplink_channel',
//           sound: 'default',
//           schedule: { at: new Date(Date.now() + 300) },
//           attachments: image ? [{ id: 'img', url: image }] : [],
//           extra: data,
//         }],
//       });

//     } 
//     // else if (type === 'action') {
//     //   // ── Type 3: Action buttons — LocalNotification with ORDER_ACTION ──
//     //   // No image. Shows action buttons (Open / View / Cancel).
//     //   await LocalNotifications.schedule({
//     //     notifications: [{
//     //       id: Number(data['notification_id']) || Math.floor(Math.random() * 2147483647),
//     //       title,
//     //       body,
//     //       largeBody: body,
//     //       smallIcon: 'ic_push_notification',
//     //       channelId: data['channel_id'] || 'deeplink_channel',
//     //       sound: 'default',
//     //       schedule: { at: new Date(Date.now() + 300) },
//     //       actionTypeId: 'ORDER_ACTION',
          
//     //       attachments: [],
//     //       extra: data,
//     //     }],
//     //   });

//     // } 
//     else if (type === 'action') {

//   const dynamicActionTypeId =
//     actions.length > 0
//       ? await this.registerDynamicActions(actions)
//       : undefined;

//   await LocalNotifications.schedule({
//     notifications: [{
//       id: Number(data['notification_id']) || Math.floor(Math.random() * 2147483647),
//       title,
//       body,
//       largeBody: body,
//       smallIcon: 'ic_push_notification',
//       channelId: data['channel_id'] || 'deeplink_channel',
//       sound: 'default',
//       schedule: { at: new Date(Date.now() + 300) },

//       // Dynamic buttons
//       actionTypeId: dynamicActionTypeId,

//       extra: data,
//     }],
//   });
// }
//     else if (type === 'image_action') {
//       // ── Type 4: Image + Action buttons ────────────────────────────────
//       // Show big picture AND action buttons together.
//       await LocalNotifications.schedule({
//         notifications: [{
//           id: Number(data['notification_id']) || Math.floor(Math.random() * 2147483647),
//           title,
//           body,
//           largeBody: body,
//           smallIcon: 'ic_push_notification',
//           largeIcon: image || undefined,
//           channelId: data['channel_id'] || 'deeplink_channel',
//           sound: 'default',
//           schedule: { at: new Date(Date.now() + 300) },
//           actionTypeId: 'ORDER_ACTION',
//           attachments: image ? [{ id: 'img', url: image }] : [],
//           extra: data,
//         }],
//       });
//     }
//   });
PushNotifications.addListener('pushNotificationReceived', async (notification) => {
    const data  = notification.data || {};
    const type  = data['type'] || 'basic';
    const title = data['title'] || notification.title || 'Notification';
    const body  = data['body']  || notification.body  || '';
    const url   = data['url']   || '/';
    const image = data['image'] || '';

    // ✅ Parse actions from data payload
    let actions: any[] = [];
    try {
        actions = JSON.parse(data['actions'] || '[]');
    } catch (e) {
        console.error('Invalid actions JSON', e);
    }

    console.log(`[FOREGROUND] type=${type}, image=${image}, actions=${actions.length}`);

    if (type === 'basic') {
        // ── No image, no actions — simple banner ──────────────────────
        this.showInAppBanner(title, body, url);

    } else if (type === 'image') {
        // ── Image only ────────────────────────────────────────────────
        await LocalNotifications.schedule({
            notifications: [{
                // id: Number(data['notification_id']) || Math.floor(Math.random() * 2147483647),
                id: Math.floor(Math.random() * 1000000),
                title,
                body,
                largeBody: body,
                smallIcon: 'ic_push_notification',
                largeIcon: image || undefined,
                channelId: data['channel_id'] || 'deeplink_channel',
                sound: 'default',
                schedule: { at: new Date(Date.now() + 300) },
                attachments: image ? [{ id: 'img', url: image }] : [],
                extra: data,
            }],
        });

    } else if (type === 'action') {
        // ── Actions only, no image ────────────────────────────────────
        const actionTypeId =
  actions.length > 0
    ? await this.registerDynamicActions(actions)
    : undefined;

console.log('ACTION TYPE ID:', actionTypeId);

        await LocalNotifications.schedule({
            notifications: [{
                id: Number(data['notification_id']) || Math.floor(Math.random() * 2147483647),
                title,
                body,
                largeBody: body,
                smallIcon: 'ic_push_notification',
                channelId: data['channel_id'] || 'deeplink_channel',
                sound: 'default',
                schedule: { at: new Date(Date.now() + 300) },
                actionTypeId,        // ✅ dynamic action buttons
                attachments: [],
                extra: data,
            }],
        });

    } else if (type === 'image_action') {
        // ── Image + Actions ───────────────────────────────────────────
        let actionTypeId: string | undefined;
        if (actions.length > 0) {
            actionTypeId = await this.registerDynamicActions(actions);
        }

        await LocalNotifications.schedule({
            notifications: [{
                id: Number(data['notification_id']) || Math.floor(Math.random() * 2147483647),
                title,
                body,
                largeBody: body,
                smallIcon: 'ic_push_notification',
                largeIcon: image || undefined,          // ✅ big image
                channelId: data['channel_id'] || 'deeplink_channel',
                sound: 'default',
                schedule: { at: new Date(Date.now() + 300) },
                actionTypeId,                           // ✅ dynamic action buttons
                attachments: image ? [{ id: 'img', url: image }] : [],
                extra: data,
            }],
        });
    }
});
  // ── LOCAL NOTIFICATION action button taps ────────────────────────────────
  // Handles: action, image_action types when app was in foreground
  // LocalNotifications.addListener('localNotificationActionPerformed', (event) => {
  //   const actionId = event.actionId;
  //   const data     = event.notification.extra || {};

  //   console.log(`[LOCAL ACTION] actionId=${actionId}`);

  //   if (actionId === 'open') {
  //     this.router.navigateByUrl(data?.url || '/home');
  //   } else if (actionId === 'view') {
  //     this.router.navigateByUrl('/notifications');
  //   } else if (actionId === 'cancel') {
  //     console.log('User cancelled');
  //   } else {
  //     // Default tap on notification body (no action button)
  //     if (data?.url) this.router.navigateByUrl(data.url);
  //   }
  // });
LocalNotifications.addListener('localNotificationActionPerformed', (event) => {
    const actionId = event.actionId;
    const data     = event.notification.extra || {};

    console.log(`[LOCAL ACTION] actionId=${actionId}`);

    // ✅ Parse dynamic actions from data payload
    let actions: any[] = [];
    try {
      actions = JSON.parse(data['actions'] || '[]');
    } catch (e) {
      console.error('Invalid actions JSON', e);
    }

    // ✅ Find the clicked action and navigate to its URL
    const clickedAction = actions.find((a: any) => a.action === actionId);

    if (clickedAction?.url) {
      this.router.navigateByUrl(clickedAction.url);
      return;
    }

    // ✅ Default: notification body tapped (no action button)
    if (data?.url) {
      this.router.navigateByUrl(data.url);
    }
  });
  // ── BACKGROUND / KILLED: FCM native notification tapped ──────────────────
  // For basic + image types: FCM renders the notification natively.
  // For action + image_action: also handled here when tapped from system tray.
  PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
    const data     = action.notification.data || {};
    const url      = data['url'];
    const type     = data['type'] || 'basic';
    const actionId = action.actionId; // 'tap' for body tap, or your action id

    console.log(`[FCM TAP] type=${type} actionId=${actionId}`);

    // Navigate to the notification URL
    if (url) {
      this.router.navigateByUrl(url);
    }
  });
}
  /* ---------- IN-APP BANNER (Foreground fallback) ---------- */
  // ✅ Since FCM won't show notification when app is open,
  //    display a simple in-app banner so user doesn't miss it

  // 🔥 Web Push
  async initializeWebPush() {
    // alert("hloo")
    this.NotificationsService.listenForMessages();
    let user_id = this.api.localStorage.getItem('user_id');
    console.log(user_id, 'oldtoken');

    this.NotificationsService.requestWebPermission(user_id, (token: string) => {
      const oldToken = this.api.localStorage.getItem('fcm_token');
      console.log(oldToken, token, 'oldtoken');
      if (oldToken === token) {
        console.log('Token already saved. Skipping API call.');
        return;
      }

      this.api.localStorage.setItem('fcm_token', token);

      if (this.user_id) {
        this.saveTokenToBackend(token);
      } else {
        console.warn(
          'No user_id — token obtained but not saved to backend yet',
        );
      }
    });
  }

  saveTokenToBackend(token: string) {
    this.api.saveDeviceToken(
      token,
      this.user_id,
      this.platform.is('android')
        ? 'android'
        : this.platform.is('ios')
          ? 'ios'
          : 'web',
    );
  }

  handleToastOk() {
    if (this.api.toastData?.callback) {
      this.api.toastData.callback(); // 🔥 execute callback
    }
    this.api.toastData = null; // close toast
  }

  handleToastClose() {
  // auto-dismiss path (no OK button) — fire callback here instead of at showToast() time
    const data = this.api.toastData;
    if (!data) return;          // <-- guards against a stray second emit
    this.api.toastData = null;
    if (data?.callback && !data?.showOk) {
      setTimeout(() => {
        data.callback(); // 🔥 execute callback
      }, 3000); // default duration 6s
    }
    
  }
}
